<script setup lang="ts">
import Card from 'primevue/card';
import Button from 'primevue/button';
import BaseIcon from '@/components/base/BaseIcon.vue';
import type { RiskProfileOption } from '@/composables/useKycData';

const props = defineProps<{
  riskProfiles: RiskProfileOption[];
  selectedRiskProfileId: string | null;
  loading: boolean;
}>();

const emit = defineEmits<{
  'update:selected-risk-profile-id': [value: string | null];
  'request-new-report': [];
}>();

const selectRiskProfile = (profileId: string) => {
  emit('update:selected-risk-profile-id', profileId);
};
</script>

<template>
  <Card class="w-full max-w-lg">
    <template #content>
      <div class="text-center">
        <BaseIcon icon="manage_search" class="text-6xl text-gray-400 mb-4" />
        <h2 class="text-2xl font-semibold text-gray-900 mb-2">Gerar Relatório KYX</h2>
        <p class="text-gray-600 mb-4">Nenhum relatório KYX foi gerado para esta entidade ainda. Selecione uma política de risco abaixo para começar.</p>

        <div class="space-y-4">
          <div
            v-for="profile in props.riskProfiles"
            :key="profile.id"
            @click="selectRiskProfile(profile.id)"
            :class="[
              'p-4 border rounded-lg cursor-pointer transition-all',
              props.selectedRiskProfileId === profile.id ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:bg-gray-50'
            ]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900">{{ profile.name }}</h3>
              <div class="flex items-center gap-2">
                <router-link
                  :to="{ name: 'account-admin-profile-details', params: { id: profile.id } }"
                  target="_blank"
                  class="text-gray-400 hover:text-blue-600 p-1 rounded hover:bg-blue-50 transition-colors"
                  @click.stop
                  title="Ver configurações"
                >
                  <BaseIcon icon="open_in_new" class="text-lg" />
                </router-link>
                <BaseIcon v-if="props.selectedRiskProfileId === profile.id" icon="check_circle" class="text-blue-600" />
              </div>
            </div>
            <p class="text-gray-600 mt-1 text-left">{{ profile.description }}</p>
          </div>
        </div>

        <div class="mt-4 text-center">
          <Button
            @click="emit('request-new-report')"
            label="Gerar Relatório"
            :loading="props.loading"
            :disabled="!props.selectedRiskProfileId"
          />
        </div>
      </div>
    </template>
  </Card>
</template>
